import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
// import Swal from "sweetalert2";

interface NavItem {
  name: string;
  route: string;
}

const NAV_ITEMS: NavItem[] = [
  { name: "Home", route: "#" },
  { name: "About Us", route: "/aboutus" },
  { name: "Structure", route: "/structure" },
  // { name: "Tracks", route: "/tracks" },
  { name: "Workshops", route: "/workshops" },
  { name: "Gallery", route: "/gallery" },
  { name: "Sponsors", route: "/sponsors" },
  { name: "Contact", route: "/contact" },
  // { name: "Media Presence", route: "/mediapresence" },
];

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.css"],
})
export class NavbarComponent implements OnInit {
  readonly navItems: NavItem[] = NAV_ITEMS;

  constructor(private router: Router) {}

  ngOnInit(): void {}

  status: boolean = false;
  clickEvent() {
    this.status = !this.status;
  }

  isShow = true;
  isOpen = true;
  mid = document.querySelector("#mid");
  toggleDisplay(event: any) {
    this.isShow = !this.isShow;
    this.isOpen = !this.isOpen;
    // event.srcElement.classList.toggle("static");
  }

  register() {
    this.router.navigateByUrl("/login");
    // Swal.fire('Registration has been Closed!')
  }
}
